import { render } from "./EventPreviewInfo.vue?vue&type=template&id=a1977c9e&ts=true"
import script from "./EventPreviewInfo.vue?vue&type=script&lang=ts"
export * from "./EventPreviewInfo.vue?vue&type=script&lang=ts"

import "./EventPreviewInfo.vue?vue&type=style&index=0&id=a1977c9e&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__